import { File, FileNameTypes, FileTypes, FileUploadStatus } from '@/__generated__/graphql';
import { generateUUIDv4 } from './string';

type Options = {
  poiName: string | undefined | null;
  poiId: string | undefined | null;
  imageType: 'viewer' | 'viewpoint';
};

export const createScreenShotNameFromResourcePath = ({ poiName, imageType, poiId }: Options) =>
  `ss_${imageType}_${poiName}_${poiId}.jpeg`;

export const createFileObjectFromScreenShotPath = ({
  poiName,
  poiId,
  resourcePath,
  imageType,
}: Options & {
  resourcePath: string | undefined | null;
}): File | undefined => {
  if (!resourcePath) return;

  return {
    id: generateUUIDv4(),
    fileName: createScreenShotNameFromResourcePath({ poiName, imageType, poiId }),
    resourcePath: resourcePath || '',
    name: FileNameTypes.PoiAttachments,
    type: FileTypes.Jpeg,
    uploadStatus: FileUploadStatus.Success,
  };
};
